import { Firmware } from "../../api/api-generated";
import {
  numbersMatch,
  stringIncludesIgnoreCaseIgnoreNullSubstring,
} from "../../utils/comparisons";
import { FirmwareFilter, FirmwareForm } from "./linksTypes";

export const firmwareValidator = (item: FirmwareForm) => {
  if (
    !item.name ||
    !item.link ||
    !item.hardwareType ||
    !item.userguideName ||
    !item.userguideLink
  )
    return false;
  return true;
};

export const filterFirmware = (item: Firmware, filters: FirmwareFilter) => {
  if (
    filters.hardwareType &&
    !numbersMatch(item.hardwareTypeId, filters.hardwareType.id)
  )
    return false;
  if (
    filters.name &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(item.name, filters.name)
  )
    return false;
  return true;
};

export const firmwareMiddlware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: { id: number; [key: string]: any },
  autoboxLabel?: string
) => {
  if (autoboxLabel && autoboxLabel === "hardwareType")
    return { hardwareType: autoboxValue };
  if (autoboxLabel && autoboxLabel === "hardwareCategory") {
    if (
      state.hardwareType &&
      state.hardwareType.hardwareCategoryId === autoboxValue?.id
    ) {
      return { hardwareCategory: autoboxValue };
    } else {
      return { hardwareCategory: autoboxValue, hardwareType: null };
    }
  }
  return {};
};
